import { useState, useRef, useEffect } from 'react';

import { IconButton, Tooltip, Box } from '@material-ui/core';
import { FastForward } from "@material-ui/icons";

const AudioPlayer = ({ src, type }) => {

    const [playRate, setPlayRate] = useState(1);

    const playerRef = useRef(null);

    const getNextPlayRate = () => playRate < 2 ? playRate + 0.5 : 1

    const togglePlaybackRate = () => {

        const newPlaybackRate = getNextPlayRate();

        if (!playerRef.current)
            return;

        playerRef.current.playbackRate = newPlaybackRate;
        setPlayRate(newPlaybackRate);
    };

    useEffect(() => {
        if(!playerRef.current)
            return;

        playerRef.current.load();
    }, [src]);

    return (
        <Box display='flex' alignItems='center' gridGap={10}>

            <audio
                ref={playerRef}
                controls
                style={{ width: 400, maxWidth: 'calc(100% - 30px)' }}
            >
                <source src={src} type={type} />
                Seu dispositivo não suporta a reprodução de áudios
            </audio>

            <Tooltip title={`Acelerar: ${getNextPlayRate()}x`}>
                <IconButton
                    onClick={togglePlaybackRate} size='small'
                    color={playRate === 1 ? 'default' : 'primary'}
                >
                    {
                        playRate === 1 ?
                            <FastForward />
                            : <span style={{ width: 22, fontSize: 12 }}>{playRate}x</span>
                    }
                </IconButton>
            </Tooltip>

        </Box>
    )
}

export default AudioPlayer;